<template>
  <main>
    <div class="row">
      <div class="col-md-12">
        <TopTemplate>
          <template #left-element>
            <h3>{{ $t('title.addDm') }}</h3>
          </template>

          <template #right-element>
            <router-link
              :to="{name: 'home_works'}"
              class="btn btn-outline-primary button"
              :disabled="loading"
            >
              <i class="arrow left" />
              {{ $t('button.retour') }}
            </router-link>
          </template>
        </TopTemplate>
        <div v-if="errorMessage" class="alert alert-danger" role="alert">{{ errorMessage }}</div>
        <div v-if="is_created" class="alert alert-success" role="alert">{{ $t('common.succesDM') }}</div>
        <div class="ajout-container">
          <form novalidate @submit.prevent="onSubmitCreateDevoir" :key="key">
            <div class="row">
              <div ref="simpleselect" class="col-md-3">
                <div class="ajout-container__simple">
                  <label>
                    {{ $t('devoir.formDm.envoiA') }}
                    <sup>*</sup>
                  </label>
                  <v-select
                    v-model="devoir.selectedType"
                    :options="options"
                    label="name"
                    :searchable="true"
                    :reduce="(option) => option.id"
                    class="form-control"
                    :class="v$.devoir.selectedType.$error ? 'is-invalid' : ''"
                    @update:modelValue="ChangeType($event)"
                  >
                    <template
                      #no-options="{ search, searching, loading }"
                    >{{ $t("common.emptysearshType") }}</template>
                  </v-select>
                  <span
                    v-if="v$.devoir.selectedType.$error"
                    class="invalid-feedback"
                  >{{ v$.devoir.selectedType.$errors[0].$message }}</span>
                </div>
              </div>

              <div class="col-md-3 select-wrapper" ref="levelselect" v-show="levelShow">
                <div class="ajout-container__simple devoirmaison">
                  <label class="label">
                    {{ $t('barFiltre.newNiveau') }}
                    <sup>*</sup>
                  </label>
                  <v-select
                    v-model="devoir.selectedLevel"
                    class="form-control"
                    :searchable="true"
                    :class="v$.devoir.selectedLevel.$error ? 'is-invalid' : ''"
                    :options="levels"
                    label="name"
                    :reduce="(option) => option"
                    @update:modelValue="ChangeLevel($event)"
                  >
                    <template #no-options="{search, searching, loading}">
                      <div
                        v-if="!loading"
                        class="card mt-2 text-center d-block pt-2 pb-2"
                      >{{ $t("common.emptysearshLevels") }}</div>

                      <div v-else class="card mt-2 text-center d-block pt-2 pb-2">
                        <div class="spinner-border text-info" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    </template>
                  </v-select>
                  <span
                    v-if="v$.devoir.selectedLevel.$error"
                    class="invalid-feedback"
                  >{{ v$.devoir.selectedLevel.$errors[0].$message }}</span>
                </div>
              </div>
              <!-- :class="levelShow?'col-md-6 select-wrapper':'col-md-3 select-wrapper' " -->
              <div  class="col-md-6 select-wrapper" ref="classselect">
                <div class="ajout-container__multiple devoirmaison">
                  <label class="label">
                    {{ $t('barFiltre.classe') }}
                    <sup>*</sup>
                  </label>
                  <div>
                    <v-select
                      v-model="devoir.class_id"
                      :options="classes"
                      label="name"
                      :searchable="true"
                      :reduce="(option) => option"
                      class="form-control"
                      :disabled="disabledClass"
                      :class="v$.devoir.class_id.$error ? 'is-invalid' : ''"
                      @update:modelValue="ChangeClasses($event)"
                    >
                      <template #no-options="{search, searching, loading}">
                        <div
                          v-if="!loading"
                          class="card mt-2 text-center d-block pt-2 pb-2"
                        >{{ $t("common.emptysearchClasse") }}</div>

                        <div v-else class="card mt-2 text-center d-block pt-2 pb-2">
                          <div class="spinner-border text-info" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      </template>
                    </v-select>
                    <span
                      v-if="v$.devoir.class_id.$error"
                      class="invalid-feedback"
                    >{{ v$.devoir.class_id.$errors[0].$message }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-6 select-wrapper" v-show="studentshow">
                <div class="ajout-container__multiple">
                  <label>
                    {{ $t('message.formMsg.selectStudent') }}
                    <sup>*</sup>
                  </label>
                  <v-select
                    v-model="devoir.selectedStudent_ids"
                    label="item_data"
                    :searchable="true"
                    :options="students"
                    :reduce="(option) => option.id"
                    multiple
                    :disabled="!devoir.class_id"
                    :class="
                      v$.devoir.selectedStudent_ids.$error ? 'is-invalid' : ''
                    "
                    @update:modelValue="ChangeStudent($event)"
                  >
                    <template #no-options="{ search, searching }">
                      {{ $t("common.emptysearshStudent") }}
                    </template>
                  </v-select>
                  <div
                    v-if="v$.devoir.selectedStudent_ids.$error && studentshow"
                    class="invalid-feedback"
                  >{{ $t("validation.required") }}</div>
                </div>
              </div>
              <div v-if="existStudent" class="col-md-12 spec-inputs-check mt-2">
                    <div class="simple-input-checkbox">
                      <label class="container-checkbox">
                        <input
                          v-model="devoir.has_module_student"
                          type="checkbox"
                        />
                        <span class="checkmark" />
                      </label>
                      <label class="label check">{{ $t('message.formMsg.sentTo') }}</label>
                    </div>
                  </div>
            </div>
              <div class="row pt-4">
                <div class="col-md-6 select-wrapper">
                  <div class="ajout-container__multiple devoirmaison">
                    <label class="label">
                      {{ $t('barFiltre.newCourses') }}
                      <sup>*</sup>
                    </label>

                    <div>
                      <v-select
                        v-model="devoir.course_id"
                        :options="courses"
                        label="name"
                        :searchable="true"
                        :reduce="(option) => option.id"
                        class="form-control"
                        :disabled="!devoir.class_id"
                        :class="v$.devoir.course_id.$error ? 'is-invalid' : ''"
                      >
                        <template #no-options="{search, searching, loading}">
                          <div
                            v-if="!loading"
                            class="card mt-2 text-center d-block pt-2 pb-2"
                          >{{ $t("common.emptysearchCourse") }}</div>

                          <div
                            v-else
                            class="card mt-2 text-center d-block pt-2 pb-24"
                          >
                            <div class="spinner-border text-info" role="status">
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        </template>
                      </v-select>
                      <span
                        v-if="v$.devoir.course_id.$error"
                        class="invalid-feedback"
                      >{{ v$.devoir.course_id.$errors[0].$message }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="ajout-container__multiple date-wrapper spec-control devoirmaison">
                    <label class="label">
                      {{ $t('barFiltre.pourLe') }}
                      <sup>*</sup>
                    </label>
                    <Datepicker
                      v-model="due_date"
                      :enable-time-picker="false"
                      locale="fr"
                      autoApply
                      text-input
                      :min-date="new Date()"
                      :format="format_date_v1"
                      class="form-control"
                      :class="v$.due_date.$error ? 'is-invalid' : ''"
                      @update:modelValue="formatByDate"
                    />

                    <span
                      v-if="v$.due_date.$error"
                      class="invalid-feedback"
                    >{{ v$.due_date.$errors[0].$message }}</span>
                  </div>
                </div>
              </div>
            <div class="row">
              <div class="col-12">
                <div class="ajout-container__text devoirmaison">
                  <div class="d-flex justify-content-between align-items-center switch-wrapper">
                    <label class="label">
                      {{ $t('devoir.formDm.text') }}
                      <sup>*</sup>
                    </label>
                  </div>
                  <TinycmeEditorMsg v-model="devoir.description"  :class="{'is-invalid-cme' : characterCount > 1000 || (v$.devoir.description.$error && characterCount === 0)}" @input="handleInput" />
                  <div v-if="v$.devoir.description.$error && characterCount === 0" class="invalid-feedback">
                    {{ $t("validation.required") }}
                  </div>

                  <span v-if="characterCount > 1000" class="invalid-feedback">La longueur maximale autorisée est de 1000 caractères</span>

                  <label class="indice">{{ $t('info.sizeText') }}
                    <span v-if="characterCount > 0 && characterCount <= 1000" :class="{'character-limit-exceeded': characterCount === 1000}">( {{ characterCount }} / 1000 caractères )</span>
                    <span v-if="characterCount > 1000" class="character-limit-exceeded">( 1000 / 1000 caractères)</span>
                  </label>
                </div>
              </div>
              <div class="col-md-5">
                <div class="d-flex flex-column pt-4">
                  <label class="label label-file">
                    {{
                    $t("devoir.formDm.file")
                    }}
                  </label>
                  <div class="input-files__authorized">
                <span>{{ $t("info.authfile") }}</span>
                <span>{{ $t("info.maxFile") }}</span>
              </div>
              <label class="input-image input-files" for="otherDoc" @change="onFileChange" @click="resetFileUploader">
  {{ $t("devoir.formDm.infofile") }}
  <div class="icon-upload">
    <img src="../../assets/icons/VectorMsg.svg" />
  </div>
  <input
    id="otherDoc"
    type="file"
    ref="file"
    :multiple="true"
    class="d-none"
    accept=".pdf, .xls, .xlsx, .xlsm, .docx, .ppt, .pdf, .jpeg, .jpg, .png"
    @input="validateFiles"
    tabindex="-1"
  />
</label>

                </div>

              </div>

              <span v-if="maxFileSize" class="indice errorSizeDoc list">
                <!-- <ul>
                        <li v-for="(item,index) in maxFileSizeTab" :key="index">
                            La taille maximale pour le fichier {{ item }} est de 2Mo.
                        </li>
                </ul>-->
                {{ $t("error.errorTailleMsgWithParams")}}
              </span>
              <span v-if="maxLengthFiles" class="indice errorSizeDoc">{{ $t("error.NbItems") }}</span>

              <div class="col-md-12 files-name" v-if="tabfile.length">
                <ul class="justify-- d-flex">
                  <li v-for="(item, index) in tabfile" :key="index">
                    {{ item.name }}
                    <span class="btn-close-file" @click="deletefile(index)"></span>
                  </li>
                </ul>
              </div>

              <!-- <div class="col-12">
                <div class="simple-input-checkbox">
                  <label class="container-checkbox">
                                            <input
                                                type="checkbox"
                                                v-model="devoir.is_arabic"
                                                :value="devoir.is_arabic"
                                                :id="'arabic'"
                                            />
                                            <span class="checkmark"></span>
                  </label>
                  <label class="label" :for="'arabic'"
                                            >c'est arabe</label
                  >
                </div>
              </div>-->
              <div class="col-12 buttons">
                <div class="button-left">
                  <button
                    type="button"
                    class="btn btn-outline-primary button"
                    :disabled="loading"
                    @click="resetForm"
                  >
                    <i class="icon-Add" />
                    {{ $t('button.annuler') }}
                  </button>
                </div>
                <div class="button-right d-flex">
                  <button type="submit" class="btn button btn-primary" :disabled="loading || isConfirmed">
                    <i class="icon-Check" />
                    {{ $t('button.envoi') }}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import HomeWorkService from "../../services/home-work.service";
import vSelect from "vue-select";
import Form from "../../core/Form";
import useValidate from "@vuelidate/core";
import {
  required,
  helpers,
  requiredIf
} from "@vuelidate/validators";
import moment from "moment";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import TinycmeEditorMsg from "../../components/tinymceMsg.vue"
import _ from "lodash";
const MAX_SIZE = 2;
const DisableWhenMaxlengthDirective = {
  mounted(el, binding) {
    const maxLength = binding.value;
    el.addEventListener('input', (event) => {
      const inputValue = event.target.value;
      if (inputValue.length > maxLength) {
        el.disabled = true;
      } else {
        el.disabled = false;
      }
    });
  },
};

export default {
  name: "AjoutDm",
  components: {
    TopTemplate,
    "v-select": vSelect,
    Datepicker,
    TinycmeEditorMsg
  },
  directives: {
    disableWhenMaxlength: DisableWhenMaxlengthDirective,
  },

  data() {
    return {
      maxCharacterLimit: 1000,
      v$: useValidate(),
      due_date: null,
      key:0,
      errorMessage: null,
      devoir: new Form({
        selectedLevel: null,
        class_id: null,
        course_id: null,
        description: "",
        is_arabic: false,
        selectedType: "une_classe",
        selectedStudent_ids: [],
        has_module_student:true
      }),
      loading: false,
      classes: [],
      courses: [],
      students:[],
      levels: [],


      isConfirmed:false,
      studentsList: [],
      params: {
        class_type_id: [],
        class_ids: [],
        class_school_id: []
      },
      checked: false,
      files: [],
      filesToSend: [],
      errorSizeDoc: [],
      maxFileSize: false,
      maxLengthFiles: false,
      maxFileSizeTab: [],
      tabfile: [],
      dir: "ltr",
      requiredDescriptionLength: 1000,
      is_created: false,
      existStudent:false,
      options: [
        {
          name: "Une classe",
          id: "une_classe"
        },
        {
          name: "Un ou plusieurs élèves",
          id: "un_ou_plusieurs_eleves"
        }
      ],
      levelShow: true,
      studentshow: false,
      characterCount: 0
    };
  },
  computed: {
    disabledClass() {
      return (
        !this.devoir.selectedLevel && this.devoir.selectedType == "une_classe" || !this.devoir.selectedLevel && this.devoir.selectedType == null
      );
    },
    userModules() {
      return this.$store.state?.auth?.user?.modules;
    }
  },
  // watch: {
  //     due_date: function (val) {
  //         if (val) {
  //             let elem = this.$refs.date;
  //             elem.classList.add("nexstyle");
  //         }
  //     },
  // },
  watch: {
    'devoir.description': function(newDescription) {
      if (newDescription !== null && typeof newDescription !== 'undefined') {
        this.updateCharacterCount();
      }
    }
  },
  validations() {
    return {
      due_date: {
        required: helpers.withMessage(this.$t("validation.required"), required)
      },
      devoir: {
        selectedLevel: {
          required: requiredIf(function(nestedModel) {
            return this.levelShow;
          })
        },
        selectedType: {
          required: helpers.withMessage(
            this.$t("validation.required"),
            required
          )
        },
        selectedStudent_ids: {
          required: requiredIf(function(nestedModel) {
            return this.studentshow;
          })
        },
        class_id: {
          required: helpers.withMessage(
            this.$t("validation.required"),
            required
          )
        },
        course_id: {
          required: helpers.withMessage(
            this.$t("validation.required"),
            required
          )
        },

        description: {
          required: helpers.withMessage(
            this.$t("validation.required"),
            required
          )
        }
      }
    };
  },
  mounted() {
    this.FilterHomeWorks();
    this.moduleUser();
  },
  methods: {
    updateCharacterCount() {
const brCount = (this.devoir.description.match(/<br \/>/g) || []).length;
const nbspCount = (this.devoir.description.match(/&nbsp;/g) || []).length;
let textWithoutTags = this.devoir.description.replace(/<br \/>/g, '').replace(/&nbsp;/g, '').replace(/\s/g, '');
// Compter la longueur des textes ancrés dans les liens
const anchorTags = this.devoir.description.match(/<a href="[^"]+">([^<]+)<\/a>/g) || [];
let anchorTextLength = 0;
anchorTags.forEach(tag => {
const match = tag.match(/<a href="[^"]+">([^<]+)<\/a>/);
if (match && match[1]) {
  anchorTextLength += match[1].length;
}
});
// Retirer la longueur des balises <a> complètes pour ne compter que les textes ancrés
textWithoutTags = textWithoutTags.replace(/<ahref="[^"]+">([^<]+)<\/a>/g, '');
const textLength = textWithoutTags.length + anchorTextLength; // Ajouter la longueur des textes ancrés

this.characterCount = textLength + brCount + nbspCount;

// Réinitialiser l'erreur de validation si le texte est dans la limite
if (this.characterCount <= 1000 && this.v$.devoir.description.$error) {
  this.$nextTick(() => {
    this.v$.devoir.description.$touch();
  });
}
},

    handleInput() {
      this.updateCharacterCount();
    },

    format_date_v1(value) {
      if (value) {
        return moment(String(value)).format("DD-MM-YYYY");
      }
    },
    dateTime(value) {
      return moment(value)
        .locale("fr")
        .format("YYYY-MM-DD");
    },
    formatByDate: _.debounce(function() {
      if (this.due_date != null) {
        this.due_date = this.dateTime(this.due_date);
      }
    }, 200),
    changeLanguage() {
      if (this.checked === true) {
        this.dir = "rtl";
      } else {
        this.dir = "ltr";
      }
    },
    checkIfElementNameIsEleves() {
      return this.userModules.some(element => element.name === 'Élèves');
    },
    moduleUser() {
      this.existStudent = this.checkIfElementNameIsEleves();
    },
    FilterHomeWorks() {
      this.loading = true;
      HomeWorkService.getFilter({
        params: {
          type_id: this.params.class_type_id,
          class_type_id: this.params.class_ids,
          class_school_id: this.params.class_school_id
        }
      }).then(
        response => {
          this.classes = _.orderBy(response.data.classes, "name");
          this.courses = _.orderBy(response.data.courses, "name");
          this.levels = response.data.types;
          this.loading = false;
        },
        error => {
          this.loading = false;
        }
      );
    },
    ChangeLevel(e) {
      //  this.loading = false;
      if (e != null) {
        this.courses = [];
        this.devoir.selectedLevel = e;
        this.devoir.class_id = [];
        if (e) this.classes = _.orderBy(e.classe, "name");
      } else {
        this.params.class_type_id = [];
        this.devoir.course_id = null;
        this.devoir.class_id = null;
        this.devoir.selectedLevel = null;
      }
    },
    ChangeClasses(e) {
      //  this.loading = false;
      this.devoir.course_id = null;
      if (e) {
        this.courses = [];
        this.devoir.selectedStudent_ids=[];
        this.params.class_ids = e;
        this.params.class_school_id = e;
        this.courses = _.orderBy(e.courses, "name");
        if (e.students) {
          this.students = _.orderBy(e.students, "first_name");
          this.students.map(function(item) {
            return (item.item_data = item.first_name + " " + item.last_name);
          });
        }
      } else {
        this.params.class_ids = null;
        this.devoir.selectedStudent_ids=[];
      }
      // this.FilterHomeWorks();
    },
    onSubmitCreateDevoir() {
      this.v$.$validate();

      if (!this.v$.$error && this.characterCount <= 1000) {
        // const data = {
        //   class_type_id: this.devoir.selectedLevel.id,
        //   class_ids: this.params.class_ids.id,
        //   course_id: this.devoir.course_id,
        //   due_date: this.due_date,
        //   description: this.devoir.description,
        //   is_arabic: this.checked,
        //   files: this.files
        // };
        // console.log(data);

        let formData = new FormData();
        formData.append("_method", "POST");

        formData.append(
          "class_type_id",
          this.devoir.selectedLevel ? this.devoir.selectedLevel.id : null
        );

        formData.append("class_ids", this.params.class_ids.id);
        formData.append("course_id", this.devoir.course_id);
        formData.append("due_date", this.due_date);
        formData.append("description", this.devoir.description);
        if (this.existStudent){
          formData.append("has_module_student", this.existStudent);
        }
        formData.append("send_to", this.devoir.has_module_student ? 2 : null);
        formData.append("is_arabic", this.dir === "rtl" ? 1 : "");
        formData.append("students_ids", JSON.stringify(this.studentsList));
        for (var i = 0; i < this.tabfile.length; i++) {
          let file = this.tabfile[i];
          formData.append("files[" + i + "]", file);
        }

        const Swal = require("sweetalert2");
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-confirm  btn-primary",
            cancelButton: "btn  btn-cancel  btn-outline-primary"
          },
          buttonsStyling: false,
          showCloseButton: true
        });

        swalWithBootstrapButtons
          .fire({
            title: this.$t("common.confirmSendDevoir"),
            icon: "warning",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: this.$t("common.deletIT"),
            cancelButtonText: this.$t("common.noCancel"),
            reverseButtons: true
          })
          .then(result => {
            if (result.isConfirmed) {
              // swalWithBootstrapButtons.fire(
              //     this.$t("common.messageSend"),
              //     "",
              //     "success"
              // );
              this.isConfirmed = true;
              HomeWorkService.create(formData)
                .then(() => {
                  this.is_created = true;

                  this.scrollToTop();
                  this.$router.push({ name: "home_works" });
                })
                .then(() => {
                  this.$nextTick(() => {
                    this.devoir.reset();
                    setTimeout(() => {
                      this.v$.$reset();
                    }, 0);
                  });
                })
                .catch(error => {
                  this.is_created = false;
                  this.errorMessage = error.response.data.error;
                  this.scrollToTop();
                }).finally(()=>{
                  this.isConfirmed = false
                  this.loading = false;
                })
            }
          });
      } else {
        this.loading = false;
        this.is_created = false;
        this.scrollToTop();
      }
      // this.resetForm()
    },
    // onSubmitCreateDevoir() {
    //     this.v$.$validate(); // checks all inputs
    //     if (!this.v$.$error) {
    //         const data = {
    //             class_type_id: this.devoir.selectedLevel,
    //             class_ids: this.params.class_ids,
    //             course_id: this.devoir.course_id,
    //             due_date: this.due_date,
    //             description: this.devoir.description,
    //             is_arabic: this.devoir.is_arabic,
    //         };
    //         HomeWorkService.create(data)
    //             .then((response) => {
    //                 this.is_created = true;
    //                 this.loading = false;
    //                 this.scrollToTop();
    //             })
    //             .then(() => {
    //                 this.$nextTick(() => {
    //                     this.devoir.reset();
    //                     this.v$.$reset();
    //                 });
    //             })
    //             .catch((error) => {
    //                 this.is_created = false;
    //                 this.loading = false;
    //                 this.scrollToTop();
    //             });
    //     } else {
    //         this.loading = false;
    //         this.is_created = false;
    //         this.scrollToTop();
    //     }
    // },
    resetForm() {
      this.devoir.selectedLevel = "";
      this.devoir.class_id = "";
      this.devoir.course_id = "";
      this.due_date = "";
      this.devoir.description = "";

      this.devoir.selectedLevel = null;
      this.devoir.class_id = "";
      this.devoir.course_id=null;
      this.due_date=null;
      this.devoir.description="";
      this.devoir.selectedStudent_ids=[];
      this.params.class_type_id = [];
      this.params.class_ids = [];
      this.params.class_school_id = [];
      this.errorSizeDoc = [];
      this.filesToSend=[];
      this.tabfile = [];
      this.maxFileSize = false;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    },
    onFileChange(event) {
      this.maxLengthFiles = false;
  const files = Object.entries(event.target.files).map(([key, value]) => value);
  const newFiles = [];

  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    if (!this.tabfile.includes(file)) {
      newFiles.push(file);
    }
  }

  if (this.tabfile.length + newFiles.length <= 5) {
    this.tabfile = this.tabfile.concat(newFiles);
  }

  else {
    this.maxLengthFiles = true;
  }

  this.validateFiles();
},
    validateFiles() {
    for (let i = 0; i < this.tabfile.length; i++) {
      const file = this.tabfile[i];
      if (file.size > 2 * 1024 * 1024) {
        this.tabfile.splice(i, 1);
        this.maxFileSize = true;
        i--;
      }
    }
  },
  deletefile(index) {
    this.tabfile.splice(index, 1);
  },
  resetFileUploader() {
    this.$refs.file.value = '';
  },

    checkFilesNumber(files) {
      this.maxLengthFiles = false;
      if (files.length > 5) {
        this.maxLengthFiles = true;
      }
    },
    checkFileSize: function(file) {
      if (!file) return false;
      let size = file.size;
      this.errorSizeDoc.push(size);
      if (this.errorSizeDoc.some(item => item / 1024 / 1024 > MAX_SIZE)) {
        this.maxFileSize = true;
      } else {
        this.maxFileSize = false;
      }

      // if (size / 1024 / 1024 > MAX_SIZE) {
      //    this.maxFileSize = true;
      // } else {
      //   this.maxFileSize = false;
      // }
    },
    createNames(files) {
      this.tabfile = [];
      for (let index = 0; index < files.length; index++) {
        this.tabfile.push({ name: files[index].name });
      }
    },

    ChangeType(e) {
      this.devoir.selectedLevel = null;
      this.devoir.class_id = "";
      this.devoir.course_id=null;
      this.due_date=null;
      this.devoir.description="";
      this.devoir.selectedStudent_ids=[];
      this.params.class_type_id = [];
      this.params.class_ids = [];
      this.params.class_school_id = [];
      this.errorSizeDoc = [];
      this.filesToSend=[];
      this.tabfile = [];
      this.maxFileSize = false;
      this.FilterHomeWorks();
      this.v$.$reset();
      if (e == "un_ou_plusieurs_eleves") {
        this.levelShow = false;
        this.studentshow = true;
        let elem = this.$refs.classselect;
        elem.classList.remove("col-md-6");
        elem.classList.add("col-md-3");
        //this.key=this.key+1;
      } else if (e == "une_classe") {
        this.levelShow = true;
        this.studentshow = false;
        let elem = this.$refs.classselect;
        elem.classList.remove("col-md-3");
        elem.classList.add("col-md-6");
         //this.key=this.key+2;
      }

    },
    ChangeStudent(e) {
      // console.log(e);
      // this.studentsList = [];
      if (e != null) {
        this.studentsList = e;
        // this.studentsList.push(e);
      }
    }
  }
};
</script>
<style>
.character-limit-exceeded {
  color: #dc3545;
}
.devoirmaison .indice {
  margin-left: 0;
}
.is-invalid-cme {
  border: 1px solid #dc3545;
}
</style>
